<template>
  <div class="international-page theme-background">
    <div class="container">
      <div class="form-section">
        <h4>Luminary is not yet available in your country.</h4>
        <p>Sign up below to be the first to know when we launch in your area.</p>
        <SubscribeForm />
      </div>
    </div>
  </div>
</template>

<script>
import banner from '../../assets/images/group_8.png';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'InternationalPage',
  components: {
    SubscribeForm: () => import('../../components/subscription/SubscribeForm'),
    InternationalFooter: () => import('../../components/InternationalFooter'),
  },
  mixins: [PageMixin],
  data() {
    return {
      banner,
      pageName: 'International',
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/terms' || to.path === '/privacy') {
      next();
    } else {
      next('/international');
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.international-page {
  width: 100%;
  position: relative;

  .form-section {
    width: 50%;
    margin: auto;
    color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    h4 {
      font-size: 36px;
      font-family: $clear-sans;
      line-height: 34px;
      margin: 0;
      @media (max-width: $xs) {
        line-height: 40px;
      }
    }

    p {
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 32px;
      margin-top: 24px;
      color: #ffffff;
    }

    .el-form-item__label {
      color: #ffffff;
    }

    @media (max-width: $lg) {
      width: 80%;
    }
    @media (max-width: $sm) {
      width: 80%;
    }
    @media (max-width: $xs) {
      width: 90%;
    }
  }
}
</style>
